export { default as abap } from "./abap.js";
export { default as abnf } from "./abnf.js";
export { default as actionscript } from "./actionscript.js";
export { default as ada } from "./ada.js";
export { default as agda } from "./agda.js";
export { default as al } from "./al.js";
export { default as antlr4 } from "./antlr4.js";
export { default as apacheconf } from "./apacheconf.js";
export { default as apex } from "./apex.js";
export { default as apl } from "./apl.js";
export { default as applescript } from "./applescript.js";
export { default as aql } from "./aql.js";
export { default as arduino } from "./arduino.js";
export { default as arff } from "./arff.js";
export { default as armasm } from "./armasm.js";
export { default as arturo } from "./arturo.js";
export { default as asciidoc } from "./asciidoc.js";
export { default as asm6502 } from "./asm6502.js";
export { default as asmatmel } from "./asmatmel.js";
export { default as aspnet } from "./aspnet.js";
export { default as autohotkey } from "./autohotkey.js";
export { default as autoit } from "./autoit.js";
export { default as avisynth } from "./avisynth.js";
export { default as avroIdl } from "./avro-idl.js";
export { default as awk } from "./awk.js";
export { default as bash } from "./bash.js";
export { default as basic } from "./basic.js";
export { default as batch } from "./batch.js";
export { default as bbcode } from "./bbcode.js";
export { default as bbj } from "./bbj.js";
export { default as bicep } from "./bicep.js";
export { default as birb } from "./birb.js";
export { default as bison } from "./bison.js";
export { default as bnf } from "./bnf.js";
export { default as bqn } from "./bqn.js";
export { default as brainfuck } from "./brainfuck.js";
export { default as brightscript } from "./brightscript.js";
export { default as bro } from "./bro.js";
export { default as bsl } from "./bsl.js";
export { default as c } from "./c.js";
export { default as cfscript } from "./cfscript.js";
export { default as chaiscript } from "./chaiscript.js";
export { default as cil } from "./cil.js";
export { default as cilkc } from "./cilkc.js";
export { default as cilkcpp } from "./cilkcpp.js";
export { default as clike } from "./clike.js";
export { default as clojure } from "./clojure.js";
export { default as cmake } from "./cmake.js";
export { default as cobol } from "./cobol.js";
export { default as coffeescript } from "./coffeescript.js";
export { default as concurnas } from "./concurnas.js";
export { default as cooklang } from "./cooklang.js";
export { default as coq } from "./coq.js";
export { default as cpp } from "./cpp.js";
export { default as crystal } from "./crystal.js";
export { default as csharp } from "./csharp.js";
export { default as cshtml } from "./cshtml.js";
export { default as csp } from "./csp.js";
export { default as cssExtras } from "./css-extras.js";
export { default as css } from "./css.js";
export { default as csv } from "./csv.js";
export { default as cue } from "./cue.js";
export { default as cypher } from "./cypher.js";
export { default as d } from "./d.js";
export { default as dart } from "./dart.js";
export { default as dataweave } from "./dataweave.js";
export { default as dax } from "./dax.js";
export { default as dhall } from "./dhall.js";
export { default as diff } from "./diff.js";
export { default as django } from "./django.js";
export { default as dnsZoneFile } from "./dns-zone-file.js";
export { default as docker } from "./docker.js";
export { default as dot } from "./dot.js";
export { default as ebnf } from "./ebnf.js";
export { default as editorconfig } from "./editorconfig.js";
export { default as eiffel } from "./eiffel.js";
export { default as ejs } from "./ejs.js";
export { default as elixir } from "./elixir.js";
export { default as elm } from "./elm.js";
export { default as erb } from "./erb.js";
export { default as erlang } from "./erlang.js";
export { default as etlua } from "./etlua.js";
export { default as excelFormula } from "./excel-formula.js";
export { default as factor } from "./factor.js";
export { default as falselang } from "./false.js";
export { default as firestoreSecurityRules } from "./firestore-security-rules.js";
export { default as flow } from "./flow.js";
export { default as fortran } from "./fortran.js";
export { default as fsharp } from "./fsharp.js";
export { default as ftl } from "./ftl.js";
export { default as gap } from "./gap.js";
export { default as gcode } from "./gcode.js";
export { default as gdscript } from "./gdscript.js";
export { default as gedcom } from "./gedcom.js";
export { default as gettext } from "./gettext.js";
export { default as gherkin } from "./gherkin.js";
export { default as git } from "./git.js";
export { default as glsl } from "./glsl.js";
export { default as gml } from "./gml.js";
export { default as gn } from "./gn.js";
export { default as goModule } from "./go-module.js";
export { default as go } from "./go.js";
export { default as gradle } from "./gradle.js";
export { default as graphql } from "./graphql.js";
export { default as groovy } from "./groovy.js";
export { default as haml } from "./haml.js";
export { default as handlebars } from "./handlebars.js";
export { default as haskell } from "./haskell.js";
export { default as haxe } from "./haxe.js";
export { default as hcl } from "./hcl.js";
export { default as hlsl } from "./hlsl.js";
export { default as hoon } from "./hoon.js";
export { default as hpkp } from "./hpkp.js";
export { default as hsts } from "./hsts.js";
export { default as http } from "./http.js";
export { default as ichigojam } from "./ichigojam.js";
export { default as icon } from "./icon.js";
export { default as icuMessageFormat } from "./icu-message-format.js";
export { default as idris } from "./idris.js";
export { default as iecst } from "./iecst.js";
export { default as ignore } from "./ignore.js";
export { default as inform7 } from "./inform7.js";
export { default as ini } from "./ini.js";
export { default as io } from "./io.js";
export { default as j } from "./j.js";
export { default as java } from "./java.js";
export { default as javadoc } from "./javadoc.js";
export { default as javadoclike } from "./javadoclike.js";
export { default as javascript } from "./javascript.js";
export { default as javastacktrace } from "./javastacktrace.js";
export { default as jexl } from "./jexl.js";
export { default as jolie } from "./jolie.js";
export { default as jq } from "./jq.js";
export { default as jsExtras } from "./js-extras.js";
export { default as jsTemplates } from "./js-templates.js";
export { default as jsdoc } from "./jsdoc.js";
export { default as json } from "./json.js";
export { default as json5 } from "./json5.js";
export { default as jsonp } from "./jsonp.js";
export { default as jsstacktrace } from "./jsstacktrace.js";
export { default as jsx } from "./jsx.js";
export { default as julia } from "./julia.js";
export { default as keepalived } from "./keepalived.js";
export { default as keyman } from "./keyman.js";
export { default as kotlin } from "./kotlin.js";
export { default as kumir } from "./kumir.js";
export { default as kusto } from "./kusto.js";
export { default as latex } from "./latex.js";
export { default as latte } from "./latte.js";
export { default as less } from "./less.js";
export { default as lilypond } from "./lilypond.js";
export { default as linkerScript } from "./linker-script.js";
export { default as liquid } from "./liquid.js";
export { default as lisp } from "./lisp.js";
export { default as livescript } from "./livescript.js";
export { default as llvm } from "./llvm.js";
export { default as log } from "./log.js";
export { default as lolcode } from "./lolcode.js";
export { default as lua } from "./lua.js";
export { default as magma } from "./magma.js";
export { default as makefile } from "./makefile.js";
export { default as markdown } from "./markdown.js";
export { default as markupTemplating } from "./markup-templating.js";
export { default as markup } from "./markup.js";
export { default as mata } from "./mata.js";
export { default as matlab } from "./matlab.js";
export { default as maxscript } from "./maxscript.js";
export { default as mel } from "./mel.js";
export { default as mermaid } from "./mermaid.js";
export { default as metafont } from "./metafont.js";
export { default as mizar } from "./mizar.js";
export { default as mongodb } from "./mongodb.js";
export { default as monkey } from "./monkey.js";
export { default as moonscript } from "./moonscript.js";
export { default as n1ql } from "./n1ql.js";
export { default as n4js } from "./n4js.js";
export { default as nand2tetrisHdl } from "./nand2tetris-hdl.js";
export { default as naniscript } from "./naniscript.js";
export { default as nasm } from "./nasm.js";
export { default as neon } from "./neon.js";
export { default as nevod } from "./nevod.js";
export { default as nginx } from "./nginx.js";
export { default as nim } from "./nim.js";
export { default as nix } from "./nix.js";
export { default as nsis } from "./nsis.js";
export { default as objectivec } from "./objectivec.js";
export { default as ocaml } from "./ocaml.js";
export { default as odin } from "./odin.js";
export { default as opencl } from "./opencl.js";
export { default as openqasm } from "./openqasm.js";
export { default as oz } from "./oz.js";
export { default as parigp } from "./parigp.js";
export { default as parser } from "./parser.js";
export { default as pascal } from "./pascal.js";
export { default as pascaligo } from "./pascaligo.js";
export { default as pcaxis } from "./pcaxis.js";
export { default as peoplecode } from "./peoplecode.js";
export { default as perl } from "./perl.js";
export { default as phpExtras } from "./php-extras.js";
export { default as php } from "./php.js";
export { default as phpdoc } from "./phpdoc.js";
export { default as plantUml } from "./plant-uml.js";
export { default as plsql } from "./plsql.js";
export { default as powerquery } from "./powerquery.js";
export { default as powershell } from "./powershell.js";
export { default as processing } from "./processing.js";
export { default as prolog } from "./prolog.js";
export { default as promql } from "./promql.js";
export { default as properties } from "./properties.js";
export { default as protobuf } from "./protobuf.js";
export { default as psl } from "./psl.js";
export { default as pug } from "./pug.js";
export { default as puppet } from "./puppet.js";
export { default as pure } from "./pure.js";
export { default as purebasic } from "./purebasic.js";
export { default as purescript } from "./purescript.js";
export { default as python } from "./python.js";
export { default as q } from "./q.js";
export { default as qml } from "./qml.js";
export { default as qore } from "./qore.js";
export { default as qsharp } from "./qsharp.js";
export { default as r } from "./r.js";
export { default as racket } from "./racket.js";
export { default as reason } from "./reason.js";
export { default as regex } from "./regex.js";
export { default as rego } from "./rego.js";
export { default as renpy } from "./renpy.js";
export { default as rescript } from "./rescript.js";
export { default as rest } from "./rest.js";
export { default as rip } from "./rip.js";
export { default as roboconf } from "./roboconf.js";
export { default as robotframework } from "./robotframework.js";
export { default as ruby } from "./ruby.js";
export { default as rust } from "./rust.js";
export { default as sas } from "./sas.js";
export { default as sass } from "./sass.js";
export { default as scala } from "./scala.js";
export { default as scheme } from "./scheme.js";
export { default as scss } from "./scss.js";
export { default as shellSession } from "./shell-session.js";
export { default as smali } from "./smali.js";
export { default as smalltalk } from "./smalltalk.js";
export { default as smarty } from "./smarty.js";
export { default as sml } from "./sml.js";
export { default as solidity } from "./solidity.js";
export { default as solutionFile } from "./solution-file.js";
export { default as soy } from "./soy.js";
export { default as sparql } from "./sparql.js";
export { default as splunkSpl } from "./splunk-spl.js";
export { default as sqf } from "./sqf.js";
export { default as sql } from "./sql.js";
export { default as squirrel } from "./squirrel.js";
export { default as stan } from "./stan.js";
export { default as stata } from "./stata.js";
export { default as stylus } from "./stylus.js";
export { default as supercollider } from "./supercollider.js";
export { default as swift } from "./swift.js";
export { default as systemd } from "./systemd.js";
export { default as t4Cs } from "./t4-cs.js";
export { default as t4Templating } from "./t4-templating.js";
export { default as t4Vb } from "./t4-vb.js";
export { default as tap } from "./tap.js";
export { default as tcl } from "./tcl.js";
export { default as textile } from "./textile.js";
export { default as toml } from "./toml.js";
export { default as tremor } from "./tremor.js";
export { default as tsx } from "./tsx.js";
export { default as tt2 } from "./tt2.js";
export { default as turtle } from "./turtle.js";
export { default as twig } from "./twig.js";
export { default as typescript } from "./typescript.js";
export { default as typoscript } from "./typoscript.js";
export { default as unrealscript } from "./unrealscript.js";
export { default as uorazor } from "./uorazor.js";
export { default as uri } from "./uri.js";
export { default as v } from "./v.js";
export { default as vala } from "./vala.js";
export { default as vbnet } from "./vbnet.js";
export { default as velocity } from "./velocity.js";
export { default as verilog } from "./verilog.js";
export { default as vhdl } from "./vhdl.js";
export { default as vim } from "./vim.js";
export { default as visualBasic } from "./visual-basic.js";
export { default as warpscript } from "./warpscript.js";
export { default as wasm } from "./wasm.js";
export { default as webIdl } from "./web-idl.js";
export { default as wgsl } from "./wgsl.js";
export { default as wiki } from "./wiki.js";
export { default as wolfram } from "./wolfram.js";
export { default as wren } from "./wren.js";
export { default as xeora } from "./xeora.js";
export { default as xmlDoc } from "./xml-doc.js";
export { default as xojo } from "./xojo.js";
export { default as xquery } from "./xquery.js";
export { default as yaml } from "./yaml.js";
export { default as yang } from "./yang.js";
export { default as zig } from "./zig.js";